/* V17 · accueil et page boutique : vidéo du héros, carrousels (flèches + points), vidéos lues quand visibles, haut de page. */
(function () {
  if (window.mp17Ready) return;
  window.mp17Ready = true;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hero() {
    var v = document.querySelector('[data-mp17-video]');
    if (!v || calm) return;
    var d = window.matchMedia('(min-width: 750px)').matches;
    v.src = d ? v.getAttribute('data-d') : v.getAttribute('data-m');
    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    var b = document.querySelector('[data-mp17-pause]');
    if (!b) return;
    b.hidden = false;
    b.addEventListener('click', function () {
      if (v.paused) { v.play(); b.classList.remove('is-paused'); b.setAttribute('aria-label', 'Mettre la vidéo en pause'); }
      else { v.pause(); b.classList.add('is-paused'); b.setAttribute('aria-label', 'Lire la vidéo'); }
    });
  }

  function carousels() {
    document.querySelectorAll('[data-mp17-car]').forEach(function (c) {
      var t = c.querySelector('[data-mp17-track]');
      if (!t) return;
      var items = t.children, dots = c.querySelectorAll('.mp17-car__dots i');
      function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : t.clientWidth; }
      function idx() { return Math.round(t.scrollLeft / (step() || 1)); }
      function sync() {
        var i = Math.min(idx(), items.length - 1);
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
      }
      var pv = c.querySelector('[data-mp17-prev]'), nx = c.querySelector('[data-mp17-next]');
      if (pv) pv.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: calm ? 'auto' : 'smooth' }); });
      if (nx) nx.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: calm ? 'auto' : 'smooth' }); });
      t.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    });
  }

  function inview() {
    var vs = document.querySelectorAll('video[data-mp17-inview]');
    if (!vs.length || calm || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.4 });
    vs.forEach(function (v) { io.observe(v); });
  }

  function top() {
    document.querySelectorAll('[data-mp17-top]').forEach(function (b) {
      b.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' });
        var h = document.getElementById(b.getAttribute('data-mp17-top'));
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      });
    });
  }

  function init() { hero(); carousels(); inview(); top(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
